import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Tumbler.svg",
  "use": "Tumbler.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Tumbler.svg\"><path d=\"M46.237,50.1652A2.0022,2.0022,0,0,1,44.2418,52H19.7538a2.0019,2.0019,0,0,1-1.9951-1.8348l-2.7621-33.082A1,1,0,0,1,15.9934,16H48.0022a1,1,0,0,1,.9968,1.0832ZM19.2989,20.5416l1.2526,15A.5.5,0,0,0,21.05,36H42.946a.5.5,0,0,0,.4983-.4584l1.2525-15A.5.5,0,0,0,44.1983,20H19.7972A.5.5,0,0,0,19.2989,20.5416Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol